<template>
    <div class="jumbotron">
        <div class="tit-wrap">
            <h2 class="jumb-tit">2022</h2>
            <p class="jumb-sup">中国土木工程学会2022年学术年会</p>
        </div>
        <div class="jumb-list">
            <p class="jumb-item">第十九届中国土木工程詹天佑奖颁奖大会</p>
            <p class="jumb-item">中国土木工程学会成立</p>
            <p class="jumb-item">110周年纪念大会</p>
        </div>
        <div class="coordinate">
            <span class="address">
                <i class="city ct-dizhi"></i>
                北京
            </span>
            <div class="time">2022年9月</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "jumbotron"
};
</script>

<style lang="scss" scoped>
.jumbotron {
    margin-top: 30px;
    color: #fff;

    .jumb-tit {
        font-size: 32px;
        font-weight: bold;
    }

    .jumb-sup {
        font-size: 16px;
        font-weight: bold;
        margin-top: 6px;
    }

    .jumb-list {
        margin-top: 14px;
        .jumb-item {
            margin-top: 5px;
            font-size: 12px;

            &:last-child {
                position: relative;
                font-size: 14px;
                font-weight: bold;
                margin-top: 12px;
                padding-bottom: 15px;

                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 20px;
                    height: 4px;
                    background: #fff;
                }
            }
        }
    }

    .coordinate {
        margin-top: 20px;

        .address {
            display: inline-block;
            height: 25px;
            line-height: 25px;
            font-size: 12px;
            font-weight: bold;

            i {
                font-weight: normal;
                vertical-align: middle;
            }
        }

        .time {
            font-size: 12px;
            padding-left: 20px;
        }
    }
}
</style>